import React, { Component } from 'react';
import ajaxConfig from '../../../remote/ajaxConfig';
import dictionary from '../../../util/dictionary';
import AlertError from '../../Common/AlertError';
import AlertSuccess from '../../Common/AlertSuccess';
import SystemModal from '../../Common/SystemModal';
import TextInput from '../../Common/TextInput';

class NewSignatory extends Component {

    state={
        firstName:'',
        lastName:'',
        designation:''
    }


    onChangeFirstName=(event)=>{
        this.setState({
            firstName:event.target.value
        })
    }

    onChangeLastName=(event)=>{
        this.setState({
            lastName:event.target.value
        })
    }

    onChangeDesignation=(event)=>{
        this.setState({
            designation:event.target.value
        })
    }



    confirmSignatory=async(event)=>{
        event.preventDefault();
  
        const {firstName, lastName, designation}=this.state;
        if(firstName.length>0 && lastName.length>0 && designation.length>0)
        {
            const server_response = await ajaxConfig.create_signatory(firstName, lastName, designation);
            if(server_response.status==="OK")
            {
                this.setState({
                    info:<AlertSuccess message={server_response.message}/>,
                    firstName:'',
                    lastName:'',
                    designation:''
                })
                this.props.refresh();
            }else{
                this.setState({
                    info:<AlertError message={server_response.message}/>
                })
            }

        }else{
            this.setState({
                info:<AlertError message={dictionary._completeFields}/>
            })
        }
    }


    render() {
        return (
            
    <SystemModal id="mdl-new-signatory" title="New Signatory">
    <form method="post" className="form-horizontal" onSubmit={this.confirmSignatory}>
               {this.state.info}
               <TextInput
                            type="text"
                            label="First Name"
                            placeholder="First Name"
                            leftIcon="fa fa-user"
                            value={this.state.firstName}
                            onChange={this.onChangeFirstName} 
                            required
                            wrap
                            />
                <TextInput
                            type="text"
                            label="Last Name"
                            placeholder="Last Name"
                            leftIcon="fa fa-user"
                            value={this.state.lastName}
                            onChange={this.onChangeLastName} 
                            required
                            wrap
                            />
           
           <TextInput
                            type="text"
                            label="Designation"
                            placeholder="Designation"
                            leftIcon="fa fa-briefcase"
                            value={this.state.designation}
                            onChange={this.onChangeDesignation} 
                            required
                            wrap
                            />

           
    

            <div className="row">&nbsp;</div>


       
            <div className="row">&nbsp;</div>
            
            <div className="modal-footer no-border">
                <button type="submit" className="btn btn-primary">Save Signatory</button>
            </div>

    </form> 

   

    </SystemModal>
        );
    }
}

export default NewSignatory;